import React from 'react';
import { ABOUT_US } from '../../data/mock';
import { Heart, Users, Award } from 'lucide-react';

export const AboutUs = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={ABOUT_US.image}
                alt="Person caring for a pet"
                className="w-full h-auto object-cover aspect-[4/5]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent" />
            </div>
            
            {/* Trust badges */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-5 hidden md:flex items-center gap-4">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center border-2 border-white">
                  <Heart className="w-5 h-5 text-teal-600" />
                </div>
                <div className="w-10 h-10 rounded-full bg-cyan-100 flex items-center justify-center border-2 border-white">
                  <Users className="w-5 h-5 text-cyan-600" />
                </div>
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center border-2 border-white">
                  <Award className="w-5 h-5 text-orange-600" />
                </div>
              </div>
              <div>
                <p className="font-semibold text-slate-800">Licensed Brokers</p>
                <p className="text-sm text-slate-500">FL • NC • VA</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Who We Are
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-8">
              {ABOUT_US.title}
            </h2>
            
            <div className="space-y-6">
              {ABOUT_US.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-lg text-slate-600 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
            
            <div className="mt-10 pt-8 border-t border-slate-200">
              <p className="text-slate-500 font-medium flex items-center gap-2">
                <Award className="w-5 h-5 text-teal-600" />
                {ABOUT_US.trustLine}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
